import {
    RESET_STEP2_VALIDATION,
    SET_NAME_VALID,
    SET_PURPOSE_VALID,
    SET_QUOTA_VALID,
    SET_TITLE_VALID
} from "../../actions/types";

// const valid ={isValid : true, message : "" }
const invalid = {isValid : false, message : ""}

const initialState = {
    TitleValid: invalid,
    NameValid: invalid,
    PurposeValid:invalid
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_NAME_VALID:
            return {
                ...state,
                NameValid: action.payload
            };

        case SET_TITLE_VALID:
            return {
                ...state,
                TitleValid: action.payload
            };

        case SET_PURPOSE_VALID:
            return{
                ...state,
                PurposeValid: action.payload
            }
        case SET_QUOTA_VALID:
            return{
                ...state,
                QuotaValid: action.payload
            }
        case RESET_STEP2_VALIDATION:
            return {
                ...state,
                TitleValid: invalid,
                NameValid: invalid,
                PurposeValid: invalid
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/StepsValidationReducer/Step2ValidationResult.js